import React, { Component } from 'react'
import ModelTable from '../../common/ModelTable'
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';
import { Icon } from 'antd';

export default class RelationJde extends Component {
    state={
        record:{},
    }

    show = record => {
        this.setState({ record }, () => {
            this.ModelTableRef.show(record)
        })
    }

    showContractAttachment = record => {
        this.ContractAttachmentRef.show(record)
    }

    getColumns = () => ([
        {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 120,
            render: (text, record, index) => {
                return <span>{text}<Icon type="paper-clip" style={{color: '#ffbf00', cursor: 'pointer'}} onClick={() => this.showContractAttachment(record)}/></span>
            }
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            width: 120
        }, {
            title: '客户全名',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 120,
        }, {
            title: '客户JDE号',
            dataIndex: 'customerJdeCode',
            key: 'customerJdeCode',
            width: 100,
        }, {
            title: '合同性质',
            dataIndex: 'contractNatureShow',
            key: 'contractNatureShow',
            width: 80,
        }, {
            title: '合同额含税/人民币',
            dataIndex: 'jdeContractAmountShow',
            key: 'jdeContractAmountShow',
            width: 100,
        }, {
            title: '合同开始时间',
            dataIndex: 'startTimeShow',
            key: 'startTimeShow',
            width: 100,
        }, {
            title: '合同结束时间',
            dataIndex: 'endTimeShow',
            key: 'endTimeShow',
            width: 100,
        }
    ])

    getContractColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60,
    }, {
        title: '附件名称',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
            const { id, name } = record;
            return <a onClick={e => this.downLoadFile(e, id)}>{name}</a>
        }
    }]

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    render() {
        const { record:{ relationJdeId }} = this.state;
        const config = {
            modelTitle: '关联JDE',
            modelWidth: 800,
            tableColumns: this.getColumns(),
            loadDataUrl: API_URL.contract.queryInvestigationJdeContractById,
            queryData: {
                relationJdeId,
            },
            resData: 'investigationJdeContract',
            resDataType: 'obj'
        }
        const ContractConfig = {
            modelTitle: '合同附件',
            modelWidth: 500,
            tableColumns: this.getContractColumns(),
            getFileDateSource: true,
            loadDataUrl: API_URL.contract.queryJdeCodeEnclosure,
            queryData: {
                type: 'contractappend',
            },
            queryDatas:[ 'investigationJdeContractId' ],
            resData: 'data',
            resDataType: 'arr',
        }
        return (
            <div>
                <ModelTable ref={el => this.ModelTableRef = el} {...config}/>
                <ModelTable ref={el => this.ContractAttachmentRef = el} {...ContractConfig}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/RelationJde.js